import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["standard"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { merge } from '../utils/merge';
/**
  Makes all sub-style variants inherit from the
  'standard' styling for that type scale.
*/

export var buildTypeScale = function buildTypeScale(typeScale) {
  return Object.keys(typeScale).reduce(function (accumTypeScale, typeScaleKey) {
    var _typeScale$typeScaleK = typeScale[typeScaleKey],
        standard = _typeScale$typeScaleK.standard,
        subStyles = _objectWithoutProperties(_typeScale$typeScaleK, _excluded);

    return _objectSpread(_objectSpread({}, accumTypeScale), {}, _defineProperty({}, typeScaleKey, _objectSpread({
      standard: standard
    }, Object.keys(subStyles).reduce(function (accumVariants, subStyleKey) {
      return _objectSpread(_objectSpread({}, accumVariants), {}, _defineProperty({}, subStyleKey, merge(standard, subStyles[subStyleKey])));
    }, {}))));
  }, {});
};